module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "after"
    }
  }), _c('em', [_vm._v("after Rilke")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Closed up like a mouth after a cry")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the white house has its blinds all drawn.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Out on the sundial, a peacock lies,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("causing mid-day hours to be gone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("The roses will lose themselves tonight,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("too full of petalling, in gentle agonies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My child, my friend, do not refuse the sight:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for death gives life its clarities.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb58612e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/after.vue
// module id = 78
// module chunks = 0